import { Route } from '@angular/router';
import { privacyContent } from './privacy-policy/resolver';
import { tosContent } from './terms-of-service/resolver';

export const PUBLIC_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./home/home.page'),
    data: {
      routeClass: 'home'
    }
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.page'),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'the-practice',
        data: {
          seo: {
            title: 'About'
          }
        }
      },
      {
        path: 'the-practice',
        pathMatch: 'full',
        loadComponent: () => import('./about/the-practice/the-practice.page'),
        data: {
          seo: {
            title: 'The Practice'
          }
        }
      },
      {
        path: 'finding-my-calling',
        pathMatch: 'full',
        loadComponent: () => import('./about/finding-my-calling/finding-my-calling.page'),
        data: {
          seo: {
            title: 'Finding My Calling'
          }
        }
      }
    ]
  },
  {
    path: 'contact-us',
    pathMatch: 'full',
    loadComponent: () => import('./contact-us/contact-us.page'),
    data: {
      seo: {
        title: 'Contact Us'
      }
    }
  },
  {
    path: 'portfolio',
    loadChildren: () => import('./portfolio/routes')
  },
  {
    path: 'how-we-work',
    loadComponent: () => import('./how-we-work/how-we-work.page'),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'design-approach'
      },
      {
        path: 'design-approach',
        pathMatch: 'full',
        loadComponent: () => import('./how-we-work/design-approach/design-approach.page'),
        data: {
          seo: {
            title: 'Design Approach'
          }
        }
      },
      {
        path: 'services',
        pathMatch: 'full',
        loadComponent: () => import('./how-we-work/services/services.page'),
        data: {
          seo: {
            title: 'Services'
          }
        }
      },
      {
        path: 'design-process',
        pathMatch: 'full',
        loadComponent: () => import('./how-we-work/design-process/design-process.page'),
        data: {
          seo: {
            title: 'Design Process'
          }
        }
      },
      {
        path: 'design-fees',
        pathMatch: 'full',
        loadComponent: () => import('./how-we-work/design-fees/design-fees.page'),
        data: {
          seo: {
            title: 'Design Fees'
          }
        }
      }
    ]
  },
  {
    path: 'terms-of-service',
    pathMatch: 'full',
    loadComponent: () => import('./terms-of-service/terms-of-service.page'),
    resolve: {
      content: tosContent,
    },
    data: {
      seo: {
        title: 'Terms of Service'
      }
    }
  },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    loadComponent: () => import('./privacy-policy/privacy-policy.page'),
    resolve: {
      content: privacyContent,
    },
    data: {
      seo: {
        title: 'Privacy Policy'
      }
    }
  }
];